import React, { useContext, useEffect, useState } from "react";
import ProfileIMG from "../../../Images/profile.jpg";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { ROLES } from "../../../constants/roles";
import { useDispatch, useSelector } from "react-redux";
import { getAllNotifications } from "../../../redux/notificationSlice/notificationSlice";

export default function Navbar({ toggleAside, toggleDarkMode }) {
  const { user, role } = useContext(AuthContext);
  const dispatch = useDispatch();
  const { allNotifications } = useSelector((state) => state.notification);
  const [notificationsWithReadStatus, setNotificationsWithReadStatus] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    dispatch(getAllNotifications());
  }, [dispatch]);

  useEffect(() => {
    if (allNotifications) {
      const updatedNotifications = allNotifications.map((notif) => ({
        ...notif,
        isRead: notif.isRead !== undefined ? notif.isRead : false,
      }));
      setNotificationsWithReadStatus(updatedNotifications);

      const unread = updatedNotifications.filter((notif) => !notif.isRead).length;
      setUnreadCount(unread);
    }
  }, [allNotifications]);

  const getTimeAgo = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) return `منذ ${diffInSeconds} ثانية`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `منذ ${diffInMinutes} دقيقة`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `منذ ${diffInHours} ساعة`;
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) return `منذ ${diffInDays} يوم`;
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) return `منذ ${diffInMonths} شهر`;
    const diffInYears = Math.floor(diffInMonths / 12);
    return `منذ ${diffInYears} سنة`;
  };

  const handleDropdownToggle = () => {
    const updatedNotifications = notificationsWithReadStatus.map((notif) => ({
      ...notif,
      isRead: true,
    }));
    setNotificationsWithReadStatus(updatedNotifications);
    setUnreadCount(0);
  };

  return (
    <>
      <div className="container-fluid navBar ms-xxl-auto ms-xl-auto ms-lg-0 me-lg-0 me-0">
        <nav className="text-end d-flex justify-content-between align-items-center me-4 py-4">
          <div>
            <label>
              <input
                className="toggle-checkbox"
                type="checkbox"
                onChange={toggleDarkMode}
                {...(localStorage.getItem("darkMode") === "true" && {
                  checked: true,
                })}
              />
              <div className="toggle-slot">
                <div className="sun-icon-wrapper">
                  <div className="iconify sun-icon" data-icon="feather-sun" data-inline="false"></div>
                </div>
                <div className="toggle-button"></div>
                <div className="moon-icon-wrapper">
                  <div className="iconify moon-icon" data-icon="feather-moon" data-inline="false"></div>
                </div>
              </div>
            </label>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <div className="dropdown notification-dropdown">
              <button className="btn shadow-none p-0 border-0 position-relative" type="button" id="dropdownMenuNotification" data-bs-toggle="dropdown" aria-expanded="false" onClick={handleDropdownToggle}>
                {unreadCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "0.6rem" }}>
                    {unreadCount}
                  </span>
                )}
                <i className="fa-regular fa-bell text-white"></i>
              </button>
              <ul className="dropdown-menu pb-0 border-0" style={{ width: "450px", height: "400px", overflowY: "scroll" }} aria-labelledby="dropdownMenuNotification">
                {notificationsWithReadStatus?.map((notification) => (
                  <li className="mb-3 bg-white" key={notification.id}>
                    <a href="#" className="dropdown-item d-flex align-items-center py-2">
                      <div className="me-3 notification-icon d-flex align-items-center justify-content-center rounded-circle">
                        <i className="fal fa-envelope"></i>
                      </div>
                      <div>
                        <h5 className="notification-label fs-6 mb-0">{notification?.message}</h5>
                        <span className="notification-subtext ar-light">{getTimeAgo(notification?.createdAt)}</span>
                      </div>
                    </a>
                  </li>
                ))}
                {/* <a href="notification.html" className="dropdown-item show-all-notification text-center p-2 text-muted ar-medium">
                  مشاهدة جميع الاشعارات
                </a> */}
              </ul>
            </div>
            {user && (
              <div className="d-flex me-3">
                <div className="d-flex flex-column ms-2 userInfo">
                  <p className="mb-0">{user?.name || "user"}</p>
                  <p className="mb-0">{role === ROLES.OWNER ? "مدير الشركة" : role === ROLES.MANAGER ? "مدير الموظفين" : "موظف"}</p>
                </div>
                <figure className="ms-3 rounded">
                  <Link to="/Profile">
                    <img src={ProfileIMG} className="rounded-5 user-image" alt="profile" />
                  </Link>
                </figure>
              </div>
            )}
            <div className="mb-2">
              <i className="fa-solid fa-bars fa-lg d-xxl-none d-xl-none d-lg-inline" onClick={toggleAside}></i>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}
